import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import { sticky } from '../../../../constants/helperCssRules';

const useStyles = makeStyles(
  ({ palette: { primary }, breakpoints, spacing }) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr',
      gridColumnGap: 8,
      paddingBottom: spacing(3),
      width: 'fit-content',
      [breakpoints.up('xl')]: {
        gridTemplateColumns: '298px 1fr',
      },
      ...sticky(primary.white, 223, 98),
    },
    label: {
      alignItems: 'center',
      display: 'flex',
    },
    employeesWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    daysWrapper: {
      width: 'fit-content',
    },
    monthLabelWrapper: {
      width: 'fit-content',
    },
    weekLabelWrapper: {
      display: 'grid',
      gridColumnGap: 2,
      gridTemplateColumns: 'repeat(5, 152px)',
      [breakpoints.up('xLg')]: {
        gridTemplateColumns: 'repeat(5, 180px)',
      },
      [breakpoints.up('xl')]: {
        gridTemplateColumns: 'repeat(5, 194px)',
      },
    },
    daysOfWeekWrapper: {
      display: 'grid',
      gridColumnGap: 2,
      gridTemplateColumns: ({ daysCount }) => `repeat(${daysCount}, 20px)`,
      [breakpoints.up('xLg')]: {
        gridTemplateColumns: ({ daysCount }) => `repeat(${daysCount}, 24px)`,
      },
      [breakpoints.up('xl')]: {
        gridTemplateColumns: ({ daysCount }) => `repeat(${daysCount}, 26px)`,
      },
      marginTop: spacing(1),
    },
    dayWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    dayOfTheWeek: {
      boxSizing: 'border-box',
      color: primary.bluish4,
      lineHeight: '20px',
      textAlign: 'center',
      width: 20,
      height: 20,
      [breakpoints.up('xLg')]: {
        width: 24,
      },
      [breakpoints.up('xl')]: {
        width: 26,
      },
    },
    dayNumber: {
      boxSizing: 'border-box',
      lineHeight: '20px',
      textAlign: 'center',
      width: 20,
      height: 20,
      [breakpoints.up('xLg')]: {
        width: 24,
      },
      [breakpoints.up('xl')]: {
        width: 26,
      },
    },
    currentDayNumber: {
      backgroundColor: primary.blue6,
      borderBottom: `2px solid ${primary.blue2}`,
    },
  })
);

const Header = ({ translations, calendar, selectedUsersCount }) => {
  const classes = useStyles({ daysCount: calendar?.intervalDays?.length || 0 });

  return (
    <div className={classes.root}>
      <div className={classes.employeesWrapper}>
        <Typography variant="h4">
          {`${translations.employee} (${selectedUsersCount})`}
        </Typography>
      </div>
      <div className={classes.daysWrapper}>
        {calendar.isMonthInterval ? (
          <Typography
            className={classNames(classes.label, classes.monthLabelWrapper)}
            variant="overline"
          >
            {calendar.monthLabel}
          </Typography>
        ) : (
          <div className={classes.weekLabelWrapper}>
            {calendar.weekLabels.map((week, index) => (
              <Typography
                key={`week_label_${week.weekDay}_${index}`}
                className={classes.label}
                variant="overline"
              >
                {week.label}
              </Typography>
            ))}
          </div>
        )}
        <div className={classes.daysOfWeekWrapper}>
          {calendar.intervalDays.map((day, index) => (
            <div
              key={`day_of_the_week_${day.dayOfTheWeek}_${day.day}_${index}`}
              className={classes.dayWrapper}
            >
              <Typography className={classes.dayOfTheWeek} variant="caption">
                {day.dayOfTheWeek}
              </Typography>
              <Typography
                className={classNames(classes.dayNumber, {
                  [classes.currentDayNumber]:
                    index === calendar.todayPositionIndex,
                })}
                variant="overline"
              >
                {day.day}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  translations: PropTypes.object.isRequired,
  calendar: PropTypes.object.isRequired,
  selectedUsersCount: PropTypes.number.isRequired,
};

export default Header;
